export const BusinessUnitConfig = {
  [process.env.VUE_APP_HOST_NAME_CM_DASHBOARD]: {
    appName: "Caribemedia",
    countryId: 1,
    googlePremierID: 5612063145,
    logoURL: "logo.svg",
    DesignedBy: "Designed by Caribe Media",
    AllRightsReserved: "Caribe Media © All Rights Reserved @year"
  },
  [process.env.VUE_APP_HOST_NAME_AXESA_DASHBOARD]: {
    appName: "Axesa",
    countryId: 2,
    googlePremierID: 2274526243,
    logoURL: "logo-axesa.svg",
    DesignedBy: "Designed by Caribe Media",
    AllRightsReserved: "CMI Digital Media, LLC. © All Rights Reserved"
  },
  [process.env.VUE_APP_HOST_NAME_INFOPAGINAS_DASHBOARD]: {
    appName: "Infopaginas",
    countryId: 3,
    googlePremierID: 0,
    logoURL: "logo-ip.svg",
    DesignedBy: "Designed by Caribe Media",
    AllRightsReserved: "InfoMedia © All Rights Reserved"
  },
  "localhost:8081": {
    appName: "Caribemedia",
    countryId: 1,
    googlePremierID: 5612063145,
    logoURL: "logo.svg",
    DesignedBy: "Designed by Caribe Media",
    AllRightsReserved: "InfoPaginas © All Rights Reserved @year"
  },
  "localhost:8083": {
    appName: "Infopaginas",
    countryId: 3,
    googlePremierID: null,
    logoURL: "logo-ip.svg",
    DesignedBy: "Designed by Caribe Media",
    AllRightsReserved: "InfoMedia © All Rights Reserved"
  },

  "localhost:8082": {
    appName: "Axesa",
    countryId: 2,
    googlePremierID: 2274526243,
    logoURL: "logo-axesa.svg",
    DesignedBy: "Designed by Caribe Media",
    AllRightsReserved: "CMI Digital Media, LLC. © All Rights Reserved"
  },
  "yodadashboard-qa.azurewebsites.net": {
    appName: "Caribemedia",
    countryId: 1,
    googlePremierID: 5612063145,
    logoURL: "logo.svg",
    DesignedBy: "Designed by Caribe Media",
    AllRightsReserved: "Caribe Media © All Rights Reserved @year"
  },
  "yodadashboard-qa-pr.azurewebsites.net": {
    appName: "Axesa",
    countryId: 2,
    googlePremierID: 2274526243,
    logoURL: "logo-axesa.svg",
    DesignedBy: "Designed by Caribe Media",
    AllRightsReserved: "CMI Digital Media, LLC. © All Rights Reserved"
  },
  "yodadashboard-ip-pr.azurewebsites.net": {
    appName: "Infopaginas",
    countryId: 3,
    googlePremierID: null,
    logoURL: "logo-ip.svg",
    DesignedBy: "Designed by Caribe Media",
    AllRightsReserved: "InfoMedia © All Rights Reserved"
  }
};
